import React, { useState } from "react";
import { Outlet } from "react-router";
import Sidebar from "../Sidebar/index";
import DashboardHeader from "../DashboardHeader/index";
import { Sheet, SheetContent } from "../../ui/sheet";
// import ProfileInfo from "./ProfileInfo";

const MainWrapper = () => {
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

    return (
        <div className="flex w-full h-screen overflow-x-clip">
            <div className="hidden sm:block">
                <Sidebar />
            </div>

            <Sheet open={mobileSidebarOpen} onOpenChange={setMobileSidebarOpen}>
                <SheetContent
                    side="left"
                    className="w-[280px] border-r border-gray-200 bg-[#F9FAFB] p-0"
                >
                    <Sidebar
                        isMobile
                        onNavigate={() => setMobileSidebarOpen(false)}
                    />
                </SheetContent>
            </Sheet>

            <div className="grow shrink-0 relative flex-1 overflow-x-hidden ">
                <div className="flex flex-col gap-y-2">
                    <DashboardHeader
                        onMenuClick={() => setMobileSidebarOpen(true)}
                    />
                    <div className="flex flex-col px-4 mt-6 sm:mx-6">
                        {/* <ProfileInfo /> */}
                        <div className="my-6">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainWrapper;
